import produce from "immer";

import {
  CLASS_CODE_ADD,
  CLASS_CODES_WATCH_ON,
  CLASS_CODES_WATCH_OFF
} from "../actions/types";

const initialState = {};

export default (state = initialState, action) => {
  return produce(state, draft => {
    // eslint-disable-next-line
    switch (action.type) {
      case CLASS_CODE_ADD:
        console.log("no need to update store");
        break;
      case CLASS_CODES_WATCH_ON:
        draft = action.payload;
        return draft;
      case CLASS_CODES_WATCH_OFF:
        // console.log(action.payload);
        // draft = action.payload;
        // return draft;
        break;
    }
  });
};
